import { ReactNode } from 'react';

interface MobileViewProps {
  children: ReactNode;
  className?: string;
}

function MobileView({ children, className = '' }: MobileViewProps) {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className={`mx-auto max-w-3xl bg-white min-h-screen ${className}`}>{children}</div>
    </div>
  );
}

export default MobileView;
